// extracted by mini-css-extract-plugin
export default {"stories-preview":"ciVNL","button":"Zwb6q"};